import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Custom Preloading Strategy that selectively preloads modules based on the router configuration.
 *
 * How it works:
 * This strategy inspects the `data` property of each route definition.
 * If a route has `data: { preload: true }`, its lazy-loaded module will be preloaded immediately after the initial bundle load.
 * Routes without this flag (or with `preload: false`) will be loaded only when the user navigates to them.
 *
 * Usage in AppRoutingModule:
 * { path: 'feature', loadChildren: ..., data: { preload: true } }
 */
@Injectable({
    providedIn: 'root'
})
export class FlagPreloadingStrategy implements PreloadingStrategy {
    preload(route: Route, load: () => Observable<any>): Observable<any> {
        return route.data && route.data['preload'] ? load() : of(null);
    }
}
